import { AppUserSiteMapping } from "models/AppUserSiteMapping";
import React from "react";
import { CSSTransition } from "react-transition-group";
import { AppUser } from "models/AppUser";
import "./LandingPage.scss";
import * as appImages from "assets/images/apps";
import * as Cookie from "js-cookie";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { profileRepository } from "repositories/profile-repository";
import authenticationService from "../../services/common-services/authentication-service";
import LandingPageDrawer from "./LandingPageDrawer/LandingPageDrawer";
import LandingPageHeader from "./LandingPageHeader";
import _ from "lodash";
import { USER_MANUAL_MASTER_ROUTE } from "config/route-consts";

export interface DecodeToken {
  exp: Number;
}
function LandingPage() {
  const location = useLocation();
  const history = useHistory();

  const userManualSite: any = React.useMemo(() => {
    return {
      appUserId: 1,
      siteId: 1,
      enabled: true,
      site: {
        id: 11,
        code: USER_MANUAL_MASTER_ROUTE,
        name: "Hướng dẫn sử dụng",
        description: "Tài liệu hướng dẫn sử dụng hệ thống Construction",
        lightIcon:
          "/rpc/utils/file/download/project/20240629/d193ed29-03a1-4fc7-90cc-3bbb4fbaa1a6/hdsd1.jpg",
        lightLogo:
          "/rpc/utils/public-file/download/site/20230228/5c9a17c1-0606-4353-9720-6924496822a4.png",
        darkIcon:
          "/rpc/utils/public-file/download/site/20230228/aff9e93f-57bb-4674-b871-6a3bc77a3a07.png",
        darkLogo:
          "/rpc/utils/public-file/download/site/20230228/40eb12c7-474a-4c5c-a019-ccce91065e36.png",
        siteTypeId: 3,
        isDisplay: true,
        siteType: {
          id: 3,
          code: "Setting",
          name: "Cài đặt",
        },
      },
    };
  }, []);

  const eConstructionSite: any = React.useMemo(() => {
    return {
      appUserId: 1,
      siteId: 98,
      enabled: true,
      site: {
        id: 98,
        code: "https://uat-con.datxanh.com.vn/eConstruction/project-master",
        name: "Xây dựng 2",
        description: "Quản lý dự án CDT 2",
        siteTypeId: 99,
        isDisplay: true,
        siteType: {
          id: 99,
          code: "Operation",
          name: "Vận hành",
        },
      },
    };
  }, []);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.has("code")) {
      authenticationService
        .switchAccount(queryParams.get("code"))
        .then((res: any) => {
          if (res.accessToken) {
            Cookie.set("Token", res.accessToken, {
              domain: `${process.env.REACT_APP_URI_COOKIE}`,
            });
            Cookie.set("access_token", res.accessToken, {
              domain: `${process.env.REACT_APP_URI_COOKIE}`,
            });
            Cookie.set("refreshToken", res.refreshToken, {
              domain: `${process.env.REACT_APP_URI_COOKIE}`,
            });
            queryParams.delete("code");
            history.replace({
              search: queryParams.toString(),
            });

            profileRepository.get().subscribe((res) => {
              const user = _.cloneDeep(res);
              user.appUserSiteMappings.push(userManualSite);
              user.appUserSiteMappings.push(eConstructionSite);
              setUser(user);
              localStorage.setItem("currentUserInfo", JSON.stringify(res));
            });
          }
        });
    }
  }, [history, location.search, userManualSite, eConstructionSite]);

  const firstLoad = React.useRef<boolean>(true);
  const [user, setUser] = React.useState<AppUser>();

  const token = Cookie.get("access_token");
  if (token && jwtDecode<DecodeToken>(token).exp < moment.now() / 1000) {
    window.location.href = "/login";
  }

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (firstLoad.current && !queryParams.has("code")) {
      profileRepository.get().subscribe((res) => {
        const user = _.cloneDeep(res);
        user.appUserSiteMappings.push(userManualSite);
        user.appUserSiteMappings.push(eConstructionSite);
        setUser(user);
        localStorage.setItem("currentUserInfo", JSON.stringify(res));
      });
      firstLoad.current = false;
    }
  }, [location.search, userManualSite, eConstructionSite]);

  const [showD, setShowD] = React.useState<boolean>(false);

  const [loadingLandingPage, setLoadingLandingPage] =
    React.useState<boolean>(true);

  React.useEffect(() => {
    if (user) {
      setLoadingLandingPage(false);
    }
  }, [user]);

  const startTime = React.useCallback(() => {
    const today = new Date();
    const h = today.getHours();
    let m = today.getMinutes();
    // let s = today.getSeconds();
    m = checkTime(m);
    // s = checkTime(s);
    if (document.getElementById("clock")) {
      document.getElementById("clock").innerHTML = h + ":" + m;
    }

    setTimeout(startTime, 500);
  }, []);

  function checkTime(i: any) {
    if (i < 10) {
      i = "0" + i;
    } // add zero in front of numbers < 10
    return i;
  }

  // check if list site include siteTypeId
  const handleCheckIncludeSiteType = React.useCallback(
    (siteTypeId: number) => {
      const listSiteTypeId: number[] = [];
      if (user?.appUserSiteMappings && user?.appUserSiteMappings?.length > 0) {
        user?.appUserSiteMappings.forEach(
          (siteItem: { site: any; enabled: boolean }) => {
            if (siteItem.enabled) {
              listSiteTypeId.push(siteItem?.site?.siteTypeId);
            }
          }
        );
        if (listSiteTypeId.includes(siteTypeId)) {
          return true;
        }
      }
      return false;
    },
    [user?.appUserSiteMappings]
  );

  const items = React.useCallback(
    (siteTypeId?: number) => {
      return (
        <React.Fragment>
          {user?.appUserSiteMappings?.length > 0 &&
            user?.appUserSiteMappings
              ?.filter((siteItem: { site: any }) => {
                if (siteTypeId) {
                  return siteItem?.site?.siteTypeId === siteTypeId;
                }
                return siteItem;
              })
              .sort(
                (a: any, b: any) => a?.site?.siteTypeId - b?.site?.siteTypeId
              )
              .map(
                (item: any, i: any) =>
                  item?.enabled &&
                  item.siteId < 100 && (
                    <SiteCard key={i} item={item} index={i} />
                  )
              )}
        </React.Fragment>
      );
    },
    [user]
  );

  const [isShowDrawer, setIsShowDrawer] = React.useState<boolean>(false);

  const handleClickLandingDrawer = React.useCallback(() => {
    if (isShowDrawer) {
      setIsShowDrawer(false);
    } else {
      setShowD(true);
      setTimeout(() => {
        setIsShowDrawer(true);
      }, 1);
    }
  }, [isShowDrawer]);

  return (
    <>
      <CSSTransition
        in={!loadingLandingPage}
        timeout={100}
        classNames="landing-page"
        unmountOnExit
        onLoad={startTime}
      >
        <div className="landing-page">
          <LandingPageHeader
            isShowDrawer={isShowDrawer}
            handleClick={handleClickLandingDrawer}
          />
          <div className="landing-page__content m-t--lg">
            <div className="list-site-box__wrapper">
              <div className="landing-page__list-site-box">
                {handleCheckIncludeSiteType(1) && (
                  <div
                    className={`landing-page__list-site-container p-t--lg p-b--xxl ${handleCheckIncludeSiteType(2) ||
                        handleCheckIncludeSiteType(3)
                        ? "not-last"
                        : ""
                      } `}
                  >
                    <div className="landing-page__site-grouping-title m-b--sm p-l--sm">
                      Bán hàng
                    </div>

                    <div className="list-site-wrapper">{items(1)}</div>
                  </div>
                )}

                <>
                  <div
                    className={`landing-page__list-site-container p-t--lg p-b--xxl`}
                  >
                    <div className="landing-page__site-grouping-title m-b--sm">
                      Tất cả các phân hệ
                    </div>

                    <div className="row row-cols-sm-1 row-cols-md-2 row-cols-lg-4 align-items-stretch g-4">
                      {items()}
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>

          <div className="landing-page__footer p-x--lg"></div>
          <LandingPageDrawer
            isShowDrawer={isShowDrawer}
            setIsShowDrawer={setIsShowDrawer}
            displayDrawer={showD}
            setDisplayDrawer={setShowD}
          />
        </div>
      </CSSTransition>
      <CSSTransition
        in={loadingLandingPage}
        timeout={100}
        classNames="landing-page-mask"
        unmountOnExit
      >
        <div id="loader-wrapper">
          <div id="loader"></div>

          <div className="loader-section section-left"></div>
          <div className="loader-section section-right"></div>
        </div>
      </CSSTransition>
    </>
  );
}

export interface SiteCardProps {
  index: number;
  item: AppUserSiteMapping;
}

export function SiteCard(props: AppUserSiteMapping) {
  const { item } = props;

  const handleClickSite = React.useCallback(() => {
    window.location.href = `${item?.site?.code}`;
  }, [item]);

  function getAppTempName(name: string): string {
    let appName = String(name).replaceAll("/", "");
    if (appName === "portal") {
      appName = appName + "/";
    }
    if (String(name) === USER_MANUAL_MASTER_ROUTE) {
      appName = "portal/user-manual/user-manual-master"; // Use image file name
    }
    if (String(name).includes("eConstruction")) {
      appName = "eConstruction";
    }
    const foundImg = appImages.images.find((e) => e.name === appName)?.src;
    if (foundImg) {
      return foundImg;
    }
    return "";
  }

  return (
    <div className="col">
      <div
        onClick={handleClickSite}
        className="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 app-item"
      >
        <div className={"text-center"}>
          <img
            className={"app-item__ico"}
            src={getAppTempName(item?.site?.code)}
            alt={item?.site?.name || ""}
            style={{ width: "120px", height: "120px" }}
          />
          <div className="app-item__name">{item?.site?.name}</div>
          <div className="app-item__description">{item?.site?.description}</div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
